import { type Editor } from '@tiptap/react';

/** Nearest scrollable ancestor of the editor (e.g. prose-mirror-container). */
export const getEditorScrollTarget = (editor: Editor): HTMLElement | Window => {
  let node: HTMLElement | null = editor.view.dom.parentElement;
  while (node) {
    const { overflowY } = window.getComputedStyle(node);
    if (overflowY === 'auto' || overflowY === 'scroll') {
      return node;
    }
    node = node.parentElement;
  }
  return window;
};

const opacityBelowOne = (style: CSSStyleDeclaration): boolean => {
  const opacity = Number.parseFloat(style.opacity);
  return Number.isFinite(opacity) && opacity < 1;
};

/**
 * Append target for the plain selection toolbar.
 *
 * The note scroller's `contain: layout` traps z-index, so the host starts at
 * the scroller's parent. An ancestor with opacity below 1 (the offline gate)
 * is its own stacking context, and the canvas gutter sits outside that
 * wrapper, inside the `isolate`. Walk past those faded ancestors and stop at
 * the isolate, so the toolbar's z-index competes with the gutter.
 */
export const getPlainToolbarAppendHost = (scroller: HTMLElement): HTMLElement | null => {
  let host: HTMLElement | null = scroller.parentElement;
  let node = host;

  while (node) {
    const style = window.getComputedStyle(node);
    if (style.isolation === 'isolate') {
      return node;
    }
    if (opacityBelowOne(style)) {
      host = node.parentElement;
    }
    node = node.parentElement;
  }

  return host;
};
